import { Component, OnInit, Input } from '@angular/core';
import { Configuration } from '../../../app.constants';
@Component({
  selector: 'app-popover',
  templateUrl: './popover.component.html',
  styleUrls: ['./popover.component.css']
})
export class PopoverComponent implements OnInit {
  @Input() name: any;
  serverApiUrl: any;
  constructor(
    public config: Configuration,
  ) { }

  ngOnInit() {
    this.serverApiUrl = this.config.StaticImageUrl;
    console.log('name', this.name)
  }

}
